export default __webpack_public_path__ + "static/media/10.9e08926f.png";